module.exports = __webpack_public_path__ + "static/banner_ast_soc_desktop-b3b82952bd83384c137a24e9d84c4131.png";